const geld = (schluessel, label, einheit, cent) => ({
    zeile: { art: "geld", schluessel, label, einheit },
    start: cent,
});
const prozent = (schluessel, label, wert) => ({
    zeile: { art: "prozent", schluessel, label },
    start: wert,
});
const zahl = (schluessel, label, einheit, wert) => ({
    zeile: { art: "zahl", schluessel, label, einheit },
    start: wert,
});
const BAND = {
    universal: "Universal 2,2 cm / Falten bis 3 cm",
    schwersteg: "Schwersteg 2,8 cm / Falten bis 5 cm",
    taschen: "7-Taschen 7,5 cm / Kirschfalte 8 cm",
};
const bahnen = (k, cent, abfuettern) => [
    geld(`bahnen.${k}`, BAND[k], "Bahn", cent),
    prozent(`bahnen.${k}.abfuettern`, `${BAND[k]} – abfüttern`, abfuettern),
];
const raumhoch = (k, saum, werkseitig, abfuettern) => [
    geld(`raumhoch.${k}.saum`, `${BAND[k]} – Saum-Abschluss`, "lfm", saum),
    geld(`raumhoch.${k}.werkseitig`, `${BAND[k]} – werkseitiger Abschluss`, "lfm", werkseitig),
    prozent(`raumhoch.${k}.abfuettern`, `${BAND[k]} – abfüttern`, abfuettern),
];
const aufhaengung = (k, name, bahn, saum, werkseitig, abfuettern) => [
    geld(`aufhaengung.${k}.bahn`, `${name} – Bahnenverarbeitung`, "Bahn", bahn),
    geld(`aufhaengung.${k}.raumhochSaum`, `${name} – raumhoch, Saum-Abschluss`, "lfm", saum),
    geld(`aufhaengung.${k}.raumhochWerkseitig`, `${name} – raumhoch, werkseitiger Abschluss`, "lfm", werkseitig),
    prozent(`aufhaengung.${k}.abfuettern`, `${name} – abfüttern`, abfuettern),
];
const ABSCHNITTE = [
    {
        titel: "Bahnenverarbeitung – Preis je Bahn",
        info: [
            "Standardausführung: seitlicher Saum 2 × 2 cm doppelt, Saumabschluss 10 × 2 cm einfach, Köpfchen 0,5 cm, Verbindungsart Overlock, Bleiband 50 g.",
            "Band und Bleiband (mit Zertifikat) sind inklusive. Angefangene Bahnen werden wie ganze Bahnen berechnet.",
        ],
        zeilen: [...bahnen("universal", 981, 110), ...bahnen("schwersteg", 1008, 110), ...bahnen("taschen", 1244, 90)],
    },
    {
        titel: "Raumhohe Verarbeitung – Preis je lfm",
        info: [
            "Standardausführung: seitlicher Saum 2 × 2 cm doppelt, Saumabschluss 10 × 2 cm einfach, Köpfchen 0,5 cm, Bleiband 50 g.",
            "Band und Bleiband (mit Zertifikat) sind inklusive.",
        ],
        zeilen: [
            ...raumhoch("universal", 646, 558, 110),
            ...raumhoch("schwersteg", 666, 577, 110),
            ...raumhoch("taschen", 824, 734, 90),
        ],
    },
    {
        titel: "Aufhängungen",
        info: [
            "Verdeckte Schlaufen: Köpfchen 0,5 cm, Bandbreite ca. 20 cm; transparentes Schlaufenband inklusive.",
            "Schlaufen: Breite/Höhe 5/10 cm, Abstand 15–20 cm; Fertighöhe einschließlich Schlaufen.",
            "Ösen: Nickel, Innen-Ø 4 cm, Köpfchen 2 cm, Abstand ca. 15 cm; Ösen und Ösenband inklusive.",
            "Waveband: Breite 77 mm, transparentes Band inklusive. Flachfalte: Breite 77 mm, Waveband inklusive.",
        ],
        zeilen: [
            ...aufhaengung("schlaufen", "Schlaufen", 1426, 946, 858, 80),
            ...aufhaengung("verdeckteSchlaufen", "Verdeckte Schlaufen", 1483, 980, 891, 80),
            ...aufhaengung("oesen", "Ösen", 2447, 1624, 1536, 50),
            ...aufhaengung("waveband", "Waveband", 1485, 981, 893, 80),
            ...aufhaengung("flachfalte", "Flachfalte", 1781, 1188, 1100, 60),
        ],
    },
    {
        titel: "Zusatzausführungen Bahnenverarbeitung",
        info: [],
        zeilen: [
            geld("zusatzBahnen.anderenSaum", "Anderen als Standard-Saumabschluss nähen", "Bahn", 58),
            geld("zusatzBahnen.kraeuseln", "Auf Fertigbreite kräuseln", "lfm", 51),
            geld("zusatzBahnen.bleiband70", "Bleiband (mit Zertifikat) 70 g", "lfm", 99),
            geld("zusatzBahnen.bleiband100", "Bleiband (mit Zertifikat) 100 g", "lfm", 131),
            geld("zusatzBahnen.blindstich", "Blindstich nähen", "lfm", 48),
            geld("zusatzBahnen.etikettenAufnaehen", "Etiketten aufnähen statt annähen", "Stück", 42),
            geld("zusatzBahnen.hakenRollen", "Haken / Rollen einhängen", "m", 117),
            prozent("zusatzBahnen.hoeheUeber420", "Dekorationshöhe über 420 cm", 60),
            geld("zusatzBahnen.kappnaht", "Kappnaht nähen", "lfm", 351),
            geld("zusatzBahnen.etikettenZusortieren", "Kundeneigene Etiketten zimmerweise zusortieren", "Stück", 33),
            geld("zusatzBahnen.warenschau150", "Warenschau vor Zuschnitt (bis 150 cm Stoffbreite)", "lfm", 69),
            geld("zusatzBahnen.warenschau300", "Warenschau vor Zuschnitt (bis 300 cm Stoffbreite)", "lfm", 143),
        ],
    },
    {
        // Alle Zusatzausführungen außer denen der Bahnenverarbeitung, in der Reihenfolge der
        // Seiten 17–18 (die Bleistäbchen stehen nur auf Seite 3). Die Schlüssel „zusatzRaumhoch.*“
        // stammen aus der früheren Karte „Raumhohe Verarbeitung“ und bleiben, damit gespeicherte
        // Werte gelten.
        titel: "Weitere Zusatzausführungen",
        info: ["Preise für die Anfertigung einer Einheit."],
        zeilen: [
            geld("zusatzRaumhoch.anderenSaum", "Anderen als Standard-Saumabschluss nähen", "lfm", 39),
            geld("zusatzRaumhoch.kraeuseln", "Auf Fertigbreite kräuseln", "lfm", 51),
            geld("zusatz.ausschnitt", "Ausschnitt in Dekorationen", "Stück", 799),
            geld("zusatzRaumhoch.bleibandAnketteln", "Bleiband (mit Zertifikat) anketteln, inkl. 25 g Bleiband", "lfm", 173),
            geld("zusatzRaumhoch.bleistaebchen13", "Bleistäbchen (mit Zertifikat) 13 g", "Stück", 41),
            geld("zusatzRaumhoch.bleistaebchen25", "Bleistäbchen (mit Zertifikat) 25 g", "Stück", 79),
            geld("zusatz.blende", "Blende annähen", "lfm", 413),
            geld("zusatz.bordure", "Bordüre aufnähen", "lfm", 305),
            geld("zusatz.couponzuschnitt", "Couponzuschnitt", "Stück", 304),
            prozent("zusatzRaumhoch.doppeltesKoepfchen", "Doppeltes Köpfchen nähen", 35),
            geld("zusatz.druckknoepfe", "Druckknöpfe anbringen", "Stück", 64),
            geld("zusatz.einfassung", "Einfassung auf- oder annähen", "lfm", 464),
            geld("zusatzRaumhoch.falscherSaum", "Falschen Saum nähen (bis max. 15 cm)", "lfm", 222),
            geld("zusatz.falscherSaumUeber15", "Falschen Saum nähen (über 15 cm)", "lfm", 446),
            geld("zusatz.papprolle", "Flächenvorhang auf Papprolle aufwickeln", "Stück", 201),
            geld("zusatz.flauschband", "Flauschband annähen (inkl. Flauschband)", "lfm", 327),
            geld("zusatzRaumhoch.hakenRollen", "Haken / Rollen einhängen", "m", 117),
            geld("zusatz.hakenMetall", "Haken (Metall) einhängen", "m", 170),
            geld("zusatz.keder", "Keder einnähen", "lfm", 365),
            geld("zusatzRaumhoch.etikettenZusortieren", "Kundeneigene Etiketten zimmerweise zusortieren", "Stück", 33),
            prozent("zusatzRaumhoch.volleFalte", "Mit voller Falte beginnen und enden (bei Bändern)", 40),
            geld("zusatz.moltonierung", "Moltonierung von gefütterten Dekorationen", "Bahn", 1059),
            geld("zusatz.oesenEinstanzen", "Ösen einstanzen (inkl. 10 mm Öse nickel)", "Stück", 238),
            geld("zusatz.schraegband", "Schrägband annähen", "lfm", 221),
            geld("zusatz.schraegfertigung", "Schrägfertigung", "lfm", 662),
            geld("zusatzRaumhoch.warenschau150", "Warenschau vor Zuschnitt (bis 150 cm Stoffbreite)", "lfm", 69),
            geld("zusatzRaumhoch.warenschau300", "Warenschau vor Zuschnitt (bis 300 cm Stoffbreite)", "lfm", 143),
            geld("zusatz.zuschnittoptimierung", "Zuschnittoptimierung", "lfm", 82),
            geld("zusatz.zierfalte", "Zierfalte nähen", "lfm", 191),
            geld("zusatz.wareTeilen300", "300 cm Ware teilen", "lfm", 79),
        ],
    },
    {
        titel: "Regeln",
        info: [
            "Bei Mindermenge berechnet das Atelier laut Liste 45 % Aufschlag plus Warenschau – siehe Kopffeld „Mindermengenaufschlag“.",
            "Den Aufschlag für Dekorationshöhen über 420 cm führen die Zusatzausführungen Bahnenverarbeitung.",
            "Handlingaufschlag (Seite 23/25): ab 8 Bahnen bzw. 12 lfm je zusammenhängender Dekoration +80 % ab der ersten Bahn. 0 % schaltet den Handlingaufschlag ab.",
            "Köpfchen-Aufschlag: OC-Regel, abgeleitet von „Doppeltes Köpfchen nähen“.",
        ],
        zeilen: [
            zahl("regel.bahnenMaxStoffbreite", "Bahnen: größte Stoffbreite zum Einzelpreis", "cm", 150),
            zahl("regel.bahnenFaktorBreit", "Bahnen: Preisfaktor bei breiteren Stoffen", "×", 2),
            zahl("regel.hoeheZuschlagAb", "Bahnen: Höhenzuschlag ab", "cm", 300),
            zahl("regel.hoeheZuschlagBis", "Bahnen: Höhenzuschlag bis", "cm", 420),
            geld("regel.hoeheZuschlagJe10cm", "Bahnen: Höhenzuschlag je angefangene 10 cm", "10 cm", 51),
            zahl("regel.mindestBahnen", "Mindestbestellmenge Bahnenverarbeitung", "Bahnen", 20),
            zahl("regel.mindestLfm", "Mindestbestellmenge Raumhoch", "lfm", 30),
            prozent("regel.koepfchenAufschlag", "Köpfchen über Standard oder verdecktes Vorhangband", 35),
            zahl("regel.koepfchenStandard", "Köpfchen im Standard bis", "mm", 5),
            zahl("regel.koepfchenStandardOesen", "Köpfchen bei Ösen im Standard bis", "mm", 20),
            prozent("regel.handlingProzent", "Handlingaufschlag je Dekoration", 80),
            zahl("regel.handlingAbBahnen", "Handlingaufschlag ab", "Bahnen", 8),
            zahl("regel.handlingAbLfm", "Handlingaufschlag ab", "lfm", 12),
        ],
    },
];
export const SE_DA = {
    schluessel: "se-da",
    name: "Se-Da",
    version: 1,
    ersetzt: ["se-da-spolka-z-o-o", "seda"],
    stammdaten: {
        beschreibung: "SE-DA Spółka z o.o. – Nähpreisliste für Objektausstatter.",
        strasse: "ul. Polna 10",
        plz: "13-230",
        ort: "Lidzbark",
        land: "PL",
        telefon: "+48 23 6822 100",
        fax: "+48 23 6962 933",
        email: "kontakt@se-da.pl",
        website: "www.se-da.pl",
    },
    startwerte: {
        modell: "se-da",
        version: 1,
        stand: "2026-04-15",
        mindermengeProzent: 45,
        uvpAufschlagProzent: 100,
        werte: Object.fromEntries(ABSCHNITTE.flatMap((a) => a.zeilen.map((z) => [z.zeile.schluessel, z.start]))),
        uvpVonHand: {},
    },
    abschnitte: ABSCHNITTE.map((a) => ({ titel: a.titel, info: a.info, zeilen: a.zeilen.map((z) => z.zeile) })),
};
//# sourceMappingURL=seDa.js.map